import { TAG_CATEGORIES } from 'src/constants/tag-categories'
export default function () {
  return {
    selectedTagCategory: TAG_CATEGORIES.CAT_CONTACTS,
    selectedTagIds: [],
    selectedTagsContactsCount: 0
  }
}
